<template>
    <div class="print:hidden bg-white border border-gray-100 rounded-xl shadow-sm p-3">
        <div class="grid grid-cols-2 gap-2">
            <Button data-cy="save-button" class="w-full" label="Salvează" icon="pi pi-save" severity="success" size="small"
                @click="$emit('save')" :disabled="!isPatientDataComplete || examLocked" />

            <Button data-cy="export-pdf-button" class="w-full" label="Export PDF" icon="pi pi-file-pdf" severity="info" size="small"
                @click="$emit('exportPdf')" :disabled="!isPatientDataComplete" />
            <Button v-if="hasSelectedRecord" data-cy="finalize-button" class="w-full col-span-2" label="Finalizează" icon="pi pi-lock"
                severity="warning" size="small" @click="$emit('finalize')"
                :disabled="!isPatientDataComplete || examLocked" />
            <Button data-cy="reset-button" class="w-full" label="Resetare" icon="pi pi-refresh" severity="secondary" outlined size="small"
                @click="$emit('reset')" :disabled="!isPatientDataComplete || examLocked" />
            <Button data-cy="delete-button" class="w-full" label="Șterge" icon="pi pi-trash" severity="danger" outlined size="small"
                @click="$emit('delete')" :disabled="!isPatientDataComplete || examLocked" />
        </div>
    </div>
</template>

<script setup>
import { computed } from "vue";
import Button from "primevue/button";

const props = defineProps({
    cnpPacient: {
        type: String,
        required: true
    },
    lastNamePacient: {
        type: String,
        required: true
    },
    firstNamePacient: {
        type: String,
        required: true
    },
    sexPacient: {
        type: String,
        required: true
    },
    examLocked: {
        type: Boolean,
        default: false
    },
    hasSelectedRecord: {
        type: Boolean,
        default: false
    }
});

defineEmits(["save", "exportPdf", "finalize", "reset", "delete"]);

const isPatientDataComplete = computed(() => {
    return props.cnpPacient?.trim() !== '' &&
        props.lastNamePacient?.trim() !== '' &&
        props.firstNamePacient?.trim() !== '' &&
        props.sexPacient?.trim() !== '';
});
</script>
